import { useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api"
import { createEmailTemplateToDto, EmailTemplateDtoSchema, emailTemplateFromDto } from "@/models/email-template"
import type { CreateEmailTemplate } from "@/models/email-template"

export function useCreateEmailTemplate({ onSuccess }: { onSuccess?: () => void } = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (template: CreateEmailTemplate) => {
      const dto = createEmailTemplateToDto(template)
      const response = await api.post("/api/email-templates", dto, EmailTemplateDtoSchema)
      return emailTemplateFromDto(response)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["email-templates"] })
      if (onSuccess) onSuccess()
    },
    onError: (error) => {
      console.error("Error creating email template:", error)
    },
  })
}
